export default __webpack_public_path__ + "static/OliverRun-59de4181380a1ccd62b0703bca61e22f.png";